export interface Objection {
  politeReason: string;
  realReason: string;
}

export interface QuestionnaireData {
  question1: {
    mistake: string;
    fix: string;
  };
  question2: {
    vision: string;
  };
  question3: {
    objections: Objection[];
  };
  question4: {
    solution: string;
    originStory: string;
  };
  question5: {
    resources: string[];
  };
  question6: {
    scarcity: string;
    missedOpportunity: string;
  };
  submittedAt?: string;
}

export interface Question {
  id: number;
  title: string;
  mainPrompt: string;
  subPrompt?: string;
  helperText?: string;
  fields: QuestionField[];
}

export interface SubField {
  name: string;
  label: string;
  placeholder: string;
  hintText?: string;
}

export interface QuestionField {
  name: string;
  label: string;
  placeholder: string;
  hintText?: string;
  required?: boolean;
  isArray?: boolean;
  arrayLength?: number;
  subFields?: SubField[];
}

export type FormStep = 'welcome' | 'question' | 'review' | 'processing' | 'results';

export const DEFAULT_FORM_DATA: QuestionnaireData = {
  question1: {
    mistake: '',
    fix: '',
  },
  question2: {
    vision: '',
  },
  question3: {
    objections: [
      { politeReason: '', realReason: '' },
      { politeReason: '', realReason: '' },
      { politeReason: '', realReason: '' },
    ],
  },
  question4: {
    solution: '',
    originStory: '',
  },
  question5: {
    resources: ['', '', ''],
  },
  question6: {
    scarcity: '',
    missedOpportunity: '',
  },
};
